import React from 'react';

const paths = {
  "plus": "M12 5v14 M5 12h14",
  "history": "M3 12a9 9 0 1 0 2.64-6.36L3 8 M3 3v5h5 M12 7v5l3 2",
  "key": "M10 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M10 9h11 M17 9v4 M21 9v3",
  "edit": "m4 16 11-11 4 4L8 20H4Z M14 6l4 4 M15 5l2-2 4 4-2 2",
  "delete": "M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7",
  "reason": "M4 4h16v12H9l-5 4Z M9 8a3 3 0 0 1 6 0c0 2-3 2-3 4 M12 14v.1",
  "schedule": "M4 4h16v17H4Z M8 2v4 M16 2v4 M4 9h16 M8 13h3 M8 17h7",
  "download": "M3 16v5h18v-5 M12 3v13 m-5-5 5 5 5-5",
  "file": "M5 3h9l5 5v13H5Z M14 3v5h5 M8 12h8 M8 16h5",
  "home": "m3 11 9-8 9 8 M5 9v12h14V9 M10 21v-6h4v6",
  "dashboard": "M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z",
  "calendar": "M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z M7 3v4 M17 3v4 M3 10h18",
  "my-day": "M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z M7 3v4 M17 3v4 M3 10h18 M8 15l3 3 5-5",
  "route": "M6 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z M18 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z M8 5h8a4 4 0 0 1 0 8H8a3 3 0 0 0 0 6h8",
  "map": "m3 5 6-2 6 2 6-2v16l-6 2-6-2-6 2Z M9 3v16 M15 5v16",
  "location": "M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  "visit": "M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z m-10-1 2 2 4-4",
  "warehouse": "M3 21V8l9-5 9 5v13 M3 11h18 M7 21v-6h10v6 M12 15v6 M1 21h22",
  "box": "m3 7 9-4 9 4v10l-9 4-9-4Z M3 7l9 4 9-4 M12 11v10 M7 5l10 4",
  "stock": "m8 3 4-2 4 2v5l-4 2-4-2Z M3 13l4-2 4 2v6l-4 2-4-2Z m10 0 4-2 4 2v6l-4 2-4-2Z M3 13l4 2 4-2 M7 15v6 M13 13l4 2 4-2 M17 15v6",
  "equipment": "M5 8h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Z M8 8V4h8v4 M3 13h18 M9 11v4 M15 11v4",
  "transfer": "M3 7h17 m-4-4 4 4-4 4 M21 17H4 m4-4-4 4 4 4",
  "checkout": "M3 12v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7 M12 15V3 m-4 4 4-4 4 4 M3 12h5l2 3h4l2-3h5",
  "users": "M11 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M1 21v-3a6 6 0 0 1 12 0v3 M16 3a4 4 0 0 1 0 8 M17 14a6 6 0 0 1 6 6v1",
  "crm": "M3 4h18v16H3Z M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0 M5 16a3 3 0 0 1 6 0 M15 9h3 M15 13h3",
  "company": "M5 21V3h14v18 M2 21h20 M9 7h1 M14 7h1 M9 11h1 M14 11h1 M10 21v-6h4v6",
  "vehicle": "m5 5-2 7v7h3v-3h12v3h3v-7l-2-7Z M3 12h18 M6 13v1 M18 13v1",
  "fuel": "M3 21V3h10v18 M1 21h14 M3 10h10 M13 12h2a2 2 0 0 1 2 2v3a2 2 0 0 0 4 0V8l-4-4 M18 5v4h3",
  "vacation": "M5 7H3v14h15v-5 M3 11h9 M7 5v4 M18 7a3 3 0 1 0-6 0 3 3 0 0 0 6 0 M15 1v1 M15 12v1 M21 7h1 M8 7h1 M19 3l1-1 M10 12l1-1 M19 11l1 1 M10 2l1 1",
  "report": "M4 3v18h17 M8 16v-4 M13 16V8 M18 16V5",
  "checklist": "M8 4h11v17H5V4h3 M9 2h6v4H9Z M8 10l1 1 2-2 M14 10h2 M8 16l1 1 2-2 M14 16h2",
  "notification": "M5 9a7 7 0 0 1 14 0v6l2 3H3l2-3Z M9 21h6",
  "gps": "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0 M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0 M12 1v4 M12 19v4 M1 12h4 M19 12h4",
  "settings": "M9 3h6l1 3 3 1 2 5-2 5-3 1-1 3H9l-1-3-3-1-2-5 2-5 3-1Z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  "sliders": "M4 3v10 M4 17v4 M12 3v3 M12 10v11 M20 3v12 M20 19v2 M1 13h6v4H1Z M9 6h6v4H9Z M17 15h6v4h-6Z",
  "upload": "M3 15v6h18v-6 M12 16V3 m-5 5 5-5 5 5",
  "search": "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0 m-2 5 6 6",
  "check": "m5 12 4 4L19 6",
  "warning": "m12 3 10 18H2Z M12 9v5 M12 17v.1",
  "info": "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M12 11v6 M12 7v.1",
  "sun": "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M12 2v2 M12 20v2 M2 12h2 M20 12h2 M5 5l1 1 M18 18l1 1 M5 19l1-1 M18 6l1-1",
  "moon": "M20 15A9 9 0 0 1 9 4a9 9 0 1 0 11 11",
  "message": "M3 3h18v14H8l-5 4Z M7 7h10 M7 11h7",
  "eye": "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  "eye-off": "m3 3 18 18 M10 5a11 11 0 0 1 12 7 16 16 0 0 1-3 4 M6 6a17 17 0 0 0-4 6s4 7 10 7a13 13 0 0 0 5-1 M9 9a4 4 0 0 0 6 6",
  "camera": "M3 6h4l2-3h6l2 3h4v15H3Z M16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
  "receipt": "M5 3l2 2 2-2 3 2 3-2 2 2 2-2v18l-2-2-2 2-3-2-3 2-2-2-2 2Z M9 9h6 M9 13h6",
  "signature": "m5 14 9-9 4 4-9 9-5 1Z m9-9 2-2 4 4-2 2 M3 22h18",
  "travel": "M5 3h9l5 5v13H5Z M14 3v5h5 M8 14h8 m-3-3 3 3-3 3",
  "chevron-down": "m6 9 6 6 6-6",
  "help": "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6 M12 17v.1",
  "logout": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4 M10 17l5-5-5-5 M15 12H3",
  "user": "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M4 21v-1a7 7 0 0 1 16 0v1",
  "monitor": "M3 4h18v12H3Z M8 20h8 M12 16v4",
  "close": "M6 6l12 12 M18 6 6 18",
  "phone": "M5 3h4l2 5-3 2a12 12 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2A18 18 0 0 1 3 5a2 2 0 0 1 2-2",
  "mail": "M3 5h18v14H3Z m0 0 9 8 9-8",
  "play": "M7 4v16l13-8Z",
  "lock": "M5 11h14v10H5Z M8 11V7a4 4 0 0 1 8 0v4",
  "star": "m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9Z",
  "clock": "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0 M12 7v5l3 2",
  "navigation": "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0 M16 8l-2 6-6 2 2-6Z",
  "flag": "M5 21V4 M5 4h11l-2 4 2 4H5",
  "stop": "M8 3h8l5 5v8l-5 5H8l-5-5V8Z M9 12h6",
  "folder": "M3 6h6l2 2h10v11H3Z",
  "pin": "M12 17v5 M8 3h8l-1 6 3 4H6l3-4Z"
} as const;

export type IconName = keyof typeof paths;

/** Decorative icons inherit the surrounding text colour in both themes. */
export default function AppIcon({ name, size = 20 }: { name: IconName; size?: number | string }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0 }}><path d={paths[name]} /></svg>;
}

/** Ista ikona kao HTML tekst (za Leaflet oznake na karti koje primaju HTML, ne React). */
export const iconSvg = (name: IconName, size = 16, color = 'currentColor') =>
  `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${paths[name]}"/></svg>`;

const moduleIcons: Record<string, IconName> = {
  "home": "home",
  "history": "history",
  "organization": "users",
  "driving-logs": "route",
  "role-management": "key",
  "dashboard": "dashboard",
  "my-day": "my-day",
  "map": "map",
  "visits": "visit",
  "routes": "route",
  "dispatch": "schedule",
  "task-templates": "checklist",
  "locations": "location",
  "crm": "crm",
  "warehouse": "warehouse",
  "consumables": "stock",
  "my-consumables": "stock",
  "inventory/pending-transfers": "checklist",
  "inventory/transfer-flows": "transfer",
  "my-inventory": "equipment",
  "inventory-checkout": "checkout",
  "vehicles": "vehicle",
  "fuel": "fuel",
  "travel-orders": "travel",
  "vacations": "vacation",
  "calendar": "calendar",
  "notifications": "notification",
  "gps-tracking": "gps",
  "visit-reasons": "reason",
  "users": "users",
  "companies": "company",
  "management": "sliders",
  "csv-import": "upload",
  "reports": "report",
  "settings": "settings",
  "allow-uploads": "upload",
  "visit-photos": "camera",
  "fuel-receipts": "receipt",
  "travel-receipts": "receipt",
  "vehicle-damages": "vehicle",
  "signatures": "signature",
  "system": "settings",
  "messages": "message"
};
export const iconForModule = (key: string): IconName => moduleIcons[key.replace(/^\//, '').replace(/_/g, '-')] || 'dashboard';

const symbols: Record<string, IconName> = {
  "🔑": "key",
  "✏": "edit",
  "🗑": "delete",
  "👁": "eye",
  "✏️": "edit",
  "🗑️": "delete",
  "👁️": "eye",
  "📄": "file",
  "📊": "dashboard",
  "📋": "checklist",
  "🗺️": "map",
  "📝": "visit",
  "🛣️": "route",
  "✅": "check",
  "📍": "location",
  "🤝": "crm",
  "📦": "warehouse",
  "🧰": "stock",
  "🔄": "transfer",
  "🎒": "equipment",
  "📤": "checkout",
  "🚗": "vehicle",
  "⛽": "fuel",
  "✈️": "travel",
  "🏖️": "vacation",
  "📅": "calendar",
  "🔔": "notification",
  "🛰️": "gps",
  "👥": "users",
  "👤": "users",
  "🏢": "company",
  "🎛️": "sliders",
  "📥": "upload",
  "📈": "report",
  "⚙️": "settings",
  "🔍": "search",
  "⚠️": "warning",
  "ℹ️": "info",
  "☀️": "sun",
  "🌙": "moon",
  "➕": "plus",
  "📚": "checklist",
  "🧭": "route"
};

/** Keep server-provided and translated labels as text; replace known decorative symbols only. */
export function IconText({ text }: { text: string }) {
  return <>{text.split(/(🔑|✏️|🗑️|👁️|✏|🗑|👁|📄|📊|📋|🗺️|📝|🛣️|✅|📍|🤝|📦|🧰|🔄|🎒|📤|🚗|⛽|✈️|🏖️|📅|🔔|🛰️|👥|👤|🏢|🎛️|📥|📈|⚙️|🔍|⚠️|ℹ️|☀️|🌙|➕|📚|🧭)/u).map((part, i) => symbols[part] ? <AppIcon key={i} name={symbols[part]} size="1em" /> : part)}</>;
}
